// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2Kvd3","scrollingDiv":"styles_scrollingDiv__3WejV","title":"styles_title__3B6cy","word":"styles_word__1S283","projects":"styles_projects__5q1is"};